/**
 * How a bank's labels are printed.
 *
 * Matching headings is answered i, ii, iii — lower case, as every IELTS paper
 * prints it. The importer stores every label upper case so that a key written
 * "iii" and one written "III" mark the same, which is right for scoring and
 * wrong on screen: "III" is not what a candidate sees in the exam. So the case
 * is decided here, at the point of display, and nowhere else.
 */

const ROMAN = /^[IVX]+$/;

export const isRomanBank = (options: { letter: string }[]): boolean =>
  options.length > 0 &&
  options.every((option) => ROMAN.test(option.letter)) &&
  // A-K banks contain I, V and X too; only a numeral runs past one character.
  options.some((option) => option.letter.length > 1);

export const displayLetter = (letter: string, roman: boolean): string =>
  roman ? letter.toLowerCase() : letter;
